import { fetchFromStrapi } from "@/components/shared/utils/api/fetchFromStrapi";
import { getGenericContent, localizationMap, generateAlternates } from "@/components/shared/utils/utils";
import NewsTemplate from "@/components/shared/components/templates/NewsTemplate";

const qs = require("qs");

export default function News({
  results,
  info,
  categories,
  categoryObject,
  currentPage,
  pageSize,
  translations
}) {
  return (
    <>
      <NewsTemplate
        translations={translations}
        results={results}
        info={info}
        categories={categories}
        categoryObject={categoryObject}
        currentPage={currentPage}
        pageCount={results.meta.pagination.pageCount}
        pageSize={pageSize}
      />
    </>
  );
}

export async function getServerSideProps({ locale, query }) {
  const pageSize = query.page_size || 12;
  const page = query.page || 1;
  const category = query.category || null;
  const generic_content = await getGenericContent(locale);

  const filters = category
    ? {
      news_category: {
        slug: {
          $eq: category,
        },
      },
    }
    : {
      news_category: {
        in_the_media: {
          $ne: true, // Exclude categories where "in_the_media" is true
        },
      },
    };

  const queryString = qs.stringify(
    {
      populate: "*",
      locale,
      filters,
      pagination: {
        page: page,
        pageSize: pageSize,
      },
      sort: ["date:desc"],
    },
    {
      encodeValuesOnly: true,
    }
  );

  const news_page = await fetchFromStrapi(
    `news-page?populate=*,localizations&locale=${locale}`
  );
  const res = await fetchFromStrapi(`news?${queryString}`);
  const categories = await fetchFromStrapi(
    `news-categories?fields[0]=title&fields[1]=slug&fields[2]=in_the_media&locale=${locale}`
  );
  const categoryObject = categories?.data?.filter(
    (cat) => cat.attributes.slug == category
  );

  if (!news_page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...generic_content,
      other_languages: localizationMap(news_page.data.attributes, "/news"),
      info: news_page.data,
      categoryObject: categoryObject,
      category,
      results: res,
      categories,
      currentPage: page,
      pageSize: pageSize,
      alternates: generateAlternates(news_page.data.attributes, "news"),
    },
  };
}
